import type { CSSProperties } from 'react';

/**
 * Theme tokens for Recharts' default tooltip, whose own colours are hardcoded for a light
 * page: a white box whose label inherits the page foreground, so under `.dark` it becomes
 * near-white text on white. The border carries the box in dark, where the popover surface
 * matches the card it floats over.
 */
export const CHART_TOOLTIP_STYLE = {
  contentStyle: {
    backgroundColor: 'var(--popover)',
    borderColor: 'var(--border)',
    color: 'var(--popover-foreground)',
  } satisfies CSSProperties,
  labelStyle: { color: 'var(--popover-foreground)' } satisfies CSSProperties,
};
